import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";

import {
  dialogSubtitleSx,
  dialogTitleSx,
  dialogTitleTextSx,
  modalTemplateTabsSx,
  previewModalFrameSx,
} from "../CampaignViewPage.styles";
import CampaignTemplatePreviewContent from "./CampaignTemplatePreviewContent";
import CampaignTemplateTabs from "./CampaignTemplateTabs";

export default function CampaignTemplatePreviewDialog({
  open,
  onClose,
  campaignTemplatePreviews,
  activeTemplateId,
  selectedTemplatePreview,
  hasConfiguredTemplates,
  isLoadingTemplatePreview,
  onSelectTemplate,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={dialogTitleSx}>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={dialogTitleTextSx}>Preview do modelo</Typography>
          <Typography color="text.secondary" sx={dialogSubtitleSx}>
            {selectedTemplatePreview?.title || "Modelo selecionado"}
          </Typography>
        </Box>

        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1, pb: 3 }}>
        <Stack spacing={2}>
          <CampaignTemplateTabs
            templates={campaignTemplatePreviews}
            activeTemplateId={activeTemplateId}
            onChange={onSelectTemplate}
            sx={modalTemplateTabsSx}
          />

          <Box sx={previewModalFrameSx}>
            <CampaignTemplatePreviewContent
              hasConfiguredTemplates={hasConfiguredTemplates}
              isLoading={isLoadingTemplatePreview}
              selectedTemplatePreview={selectedTemplatePreview}
            />
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
